import api from './api';

export interface LearningStream {
  id: string;
  name: 'German' | 'ML_AI' | 'Research' | 'Backend';
  status: 'Not Started' | 'In Progress' | 'On Track' | 'Behind' | 'Complete';
  target_hours: number;
  completed_hours: number;
  created_at: string;
  updated_at?: string;
}

export interface CreateStreamData {
  name: 'German' | 'ML_AI' | 'Research' | 'Backend';
  status?: 'Not Started' | 'In Progress' | 'On Track' | 'Behind' | 'Complete';
  target_hours?: number;
}

export const streamsService = {
  async getAll(): Promise<LearningStream[]> {
    const response = await api.get('/api/streams');
    return response.data;
  },

  async getById(id: string): Promise<LearningStream> {
    const response = await api.get(`/api/streams/${id}`);
    return response.data;
  },

  async create(data: CreateStreamData): Promise<LearningStream> {
    const response = await api.post('/api/streams', data);
    return response.data;
  },

  async update(id: string, data: Partial<LearningStream>): Promise<LearningStream> {
    const response = await api.patch(`/api/streams/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/streams/${id}`);
  },
};

